import "./Login.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { phoneLogin, phoneRegister, phoneChangePassword } from "./pages/happyschool_static/happyschoolApi";
import { setHsToken, setHsName, getHsUid } from "./pages/happyschool_static/hsAuth";
import { setActiveSchoolId } from "./pages/happyschool_static/activeSchool";
import { weakPasswordReason, PASSWORD_POLICY_TEXT } from "./pages/happyschool_static/passwordPolicy";

function Login() {
  const [mode, setMode] = useState("login"); // "login" | "register" | "change"
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [password2, setPassword2] = useState("");
  const [dob, setDob] = useState(""); // ngày sinh: đăng nhập lần đầu / đổi mật khẩu mặc định (= số điện thoại)
  const [needDob, setNeedDob] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showNewPassword2, setShowNewPassword2] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  // Đăng nhập KHÔNG còn qua Firebase Auth — nếu đã có token hợp lệ trong
  // localStorage (xem hsAuth.js) thì coi như đã đăng nhập, vào thẳng luôn.
  useEffect(() => {
    if (getHsUid()) { navigate("/happyschool"); return; }
    // Bị đẩy về đây vì phiên hết hạn/không hợp lệ (xem handleSessionExpired trong hsAuth.js) -> báo lý do.
    try {
      const notice = sessionStorage.getItem("hs_login_notice");
      if (notice) { sessionStorage.removeItem("hs_login_notice"); setErr(notice); }
    } catch (_) {}
  }, []);

  const switchMode = (m) => {
    setMode(m);
    setErr("");
    setOk("");
  };

  const handlePhoneLogin = async (e) => {
    e.preventDefault();
    if (!phone.trim() || !password) return;
    setBusy(true);
    setErr("");
    try {
      const { token, schoolId, name: accountName } = await phoneLogin(phone.trim(), password, dob.trim());
      setHsToken(token);
      setHsName(accountName);
      if (schoolId) setActiveSchoolId(schoolId);
      navigate("/happyschool");
    } catch (e2) {
      if (e2.needDob) setNeedDob(true);
      if (e2.mustChangePassword) { // mật khẩu hiện tại quá yếu (hoặc bị buộc đổi): bắt đổi trước khi vào
        setOldPassword(password);
        setNewPassword("");
        setNewPassword2("");
        setMode("change");
      }
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setErr("");
    if (!phone.trim() || !password) return;
    const weakReg = weakPasswordReason(password, phone);
    if (weakReg) return setErr(`${weakReg} ${PASSWORD_POLICY_TEXT}`);
    if (password !== password2) return setErr("Mật khẩu nhập lại không khớp.");
    setBusy(true);
    try {
      const { token, name: accountName } = await phoneRegister(phone.trim(), password, name.trim());
      setHsToken(token);
      setHsName(accountName);
      navigate("/happyschool");
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setErr("");
    setOk("");
    if (!phone.trim() || !oldPassword || !newPassword) return;
    const weakNew = weakPasswordReason(newPassword, phone);
    if (weakNew) return setErr(`${weakNew} ${PASSWORD_POLICY_TEXT}`);
    if (newPassword === oldPassword) return setErr("Mật khẩu mới phải khác mật khẩu cũ.");
    if (newPassword !== newPassword2) return setErr("Mật khẩu mới nhập lại không khớp.");
    setBusy(true);
    try {
      await phoneChangePassword(phone.trim(), oldPassword, newPassword, dob.trim());
      // Đổi xong -> đăng nhập luôn bằng mật khẩu mới.
      try {
        const { token, schoolId, name: accountName } = await phoneLogin(phone.trim(), newPassword);
        setHsToken(token);
        setHsName(accountName);
        if (schoolId) setActiveSchoolId(schoolId);
        navigate("/happyschool");
        return;
      } catch (_) {
        setOk("Đổi mật khẩu thành công! Hãy đăng nhập bằng mật khẩu mới.");
      }
      setOldPassword("");
      setNewPassword("");
      setNewPassword2("");
      setPassword("");
      setMode("login");
    } catch (e2) {
      if (e2.needDob) setNeedDob(true);
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };

  const isDigitsSame = (a, b) => String(a || "").replace(/\D/g, "") !== "" && String(a || "").replace(/\D/g, "") === String(b || "").replace(/\D/g, "");
  const dobInput = (
    <input type="text" className="login__textBox" value={dob} onChange={(e) => setDob(e.target.value)} placeholder="Ngày sinh (dd/mm/yyyy)" autoComplete="bday" />
  );

  return (
    <div className="login">
      <div className="background">
        <img className="img-bg" src="https://img.lovepik.com/photo/50052/3939.jpg_wh860.jpg" alt="" />
      </div>
      <div className="login__container">
        {mode === "login" ? (
          <>
            <form onSubmit={handlePhoneLogin} style={{ display: "flex", flexDirection: "column" }}>
              <input type="tel" className="login__textBox" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Số điện thoại" />
              <div className="login__pwWrap">
                <input type={showPassword ? "text" : "password"} className="login__textBox" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mật khẩu" />
                <button type="button" className="login__eyeBtn" onClick={() => setShowPassword((s) => !s)} aria-label={showPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}>
                  {showPassword ? "🙈" : "👁️"}
                </button>
              </div>
              {(needDob || isDigitsSame(password, phone)) && dobInput}
              <button type="submit" className="login__btn" disabled={busy}>
                {busy ? "Đang đăng nhập..." : "Đăng nhập"}
              </button>
            </form>
            <div className="login__hint" style={{ fontSize: 12, color: "#6b7280", margin: "6px 2px" }}>
              Nhân viên/giáo viên đăng nhập <b>lần đầu</b>: nhập <b>số điện thoại</b> vào cả ô SĐT và ô Mật khẩu, rồi nhập thêm <b>ngày sinh</b> (dd/mm/yyyy) theo hồ sơ nhà trường.
            </div>
            <div className="login__link" onClick={() => switchMode("register")}>Chưa có tài khoản? Đăng ký</div>
            <div className="login__link" onClick={() => switchMode("change")}>Đổi mật khẩu</div>
          </>
        ) : mode === "register" ? (
          <>
            <div className="login__divider" style={{ fontWeight: 700 }}>Đăng ký tài khoản</div>
            <form onSubmit={handleRegister} style={{ display: "flex", flexDirection: "column" }}>
              <input type="text" className="login__textBox" value={name} onChange={(e) => setName(e.target.value)} placeholder="Họ và tên" />
              <input type="tel" className="login__textBox" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Số điện thoại" />
              <input type="password" className="login__textBox" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mật khẩu (≥ 8 ký tự, có hoa, thường, số)" />
              <input type="password" className="login__textBox" value={password2} onChange={(e) => setPassword2(e.target.value)} placeholder="Nhập lại mật khẩu" />
              <button type="submit" className="login__btn" disabled={busy}>
                {busy ? "Đang tạo tài khoản..." : "Đăng ký & đăng nhập"}
              </button>
            </form>
            <div className="login__hint" style={{ fontSize: 12, color: "#6b7280", margin: "6px 2px" }}>{PASSWORD_POLICY_TEXT}</div>
            <div className="login__link" onClick={() => switchMode("login")}>← Quay lại đăng nhập</div>
          </>
        ) : (
          <>
            <div className="login__divider" style={{ fontWeight: 700 }}>Đổi mật khẩu</div>
            <form onSubmit={handleChangePassword} style={{ display: "flex", flexDirection: "column" }}>
              <input type="tel" className="login__textBox" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Số điện thoại" />
              <div className="login__pwWrap">
                <input type={showOldPassword ? "text" : "password"} className="login__textBox" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} placeholder="Mật khẩu cũ" />
                <button type="button" className="login__eyeBtn" onClick={() => setShowOldPassword((s) => !s)} aria-label={showOldPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}>
                  {showOldPassword ? "🙈" : "👁️"}
                </button>
              </div>
              <div className="login__pwWrap">
                <input type={showNewPassword ? "text" : "password"} className="login__textBox" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Mật khẩu mới (≥ 8 ký tự, có hoa, thường, số)" />
                <button type="button" className="login__eyeBtn" onClick={() => setShowNewPassword((s) => !s)} aria-label={showNewPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}>
                  {showNewPassword ? "🙈" : "👁️"}
                </button>
              </div>
              <div className="login__pwWrap">
                <input type={showNewPassword2 ? "text" : "password"} className="login__textBox" value={newPassword2} onChange={(e) => setNewPassword2(e.target.value)} placeholder="Nhập lại mật khẩu mới" />
                <button type="button" className="login__eyeBtn" onClick={() => setShowNewPassword2((s) => !s)} aria-label={showNewPassword2 ? "Ẩn mật khẩu" : "Hiện mật khẩu"}>
                  {showNewPassword2 ? "🙈" : "👁️"}
                </button>
              </div>
              {(needDob || isDigitsSame(oldPassword, phone)) && dobInput}
              <button type="submit" className="login__btn" disabled={busy}>
                {busy ? "Đang đổi..." : "Đổi mật khẩu"}
              </button>
            </form>
            <div className="login__hint" style={{ fontSize: 12, color: "#6b7280", margin: "6px 2px" }}>{PASSWORD_POLICY_TEXT}</div>
            <div className="login__link" onClick={() => switchMode("login")}>← Quay lại đăng nhập</div>
          </>
        )}
        {err && <div className="login__error">{err}</div>}
        {ok && <div className="login__ok">{ok}</div>}
      </div>
    </div>
  );
}
export default Login;
